module.exports = "<md-dialog flex=\"50\">\n    <md-dialog-content>\n        <div class=\"md-dialog-content\" layout=\"row\" layout-align=\"start center\" layout-wrap style=\"background:white;\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n            <p style=\"margin-bottom: 0px!important;padding-left: 10px;\">{{infoMsg}}</p>\n        </div>\n    </md-dialog-content>\n</md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/generic/views/loader.html
// module id = 482
// module chunks = 438